<script>
	import { NOTE_SLIDE_UP_TIME } from '../config.js'
	import { secondsToMin, titleClickToStart } from '../utils.js'
	import padStart from 'lodash/padStart';
  export let i = 0;
  export let style = '';
  export let startTime = false;

  $: isLink = !!startTime
  $: isChapterTitle = i === 'chapterTitle'
  $: title = isChapterTitle ? 'Click to go back to overview' : isLink ? titleClickToStart(startTime) : ''
  $: iconName = `icon-eclipses-${isChapterTitle ? 'chapter' : padStart(i + 1, 2, '0')}`
  $: classes = `icon-eclipse ${iconName} ${isLink || isChapterTitle ? 'clickable link' : ''}`

  function handleClick () {
  	if (isLink) {
  		window.goToSecond(startTime);
  	} else if (isChapterTitle) {
  		window.stop();
  	}
  }
</script>

<i
	class={classes}
	style={style}
	title={title}
	on:click={handleClick}></i>